import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table, Loader, Card} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {exemptionColumns} from '../../constants';
import {Actions} from '../../../common/actions';
import Header from '../common/Header';
import CommonTable from '../common/Table';
import './styles.scss';

class ExemptionManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'filteredRows': 0,
    };
  }

  componentDidMount() {
    if (
      hasAccessPermission(
        this.props.permissions,
        resources.ExemptionManagement,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.fetchExemptionManagementList();
  }

  handleChange = (field, value) => {
    this.setState({
      [field]: value,
    });
  };

  renderLoader() {
    return (
      <Table striped className="toyota-grid">
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan="100%">
              <Loader active inline="centered" content="Ejecutando" />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }

  render() {
    const {filteredRows} = this.state;
    const {loading, list} = this.props;

    return (
      <div className="exemption-management-container">
        <Header
          title="Administración de Porcentajes de Exoneración"
          name="cliente"
          filteredRows={filteredRows}
          detail=""
          saveChanges=""
          contentType="exemption"
        />
        <Card raised fluid className="exemption-percentage-table">
          {loading ? (
            this.renderLoader()
          ) : (
            <CommonTable
              filteredRows={filteredRows}
              list={list}
              columnsTable={exemptionColumns}
              handleChange={this.handleChange}
            />
          )}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'loading': state.exemptionManagment.loading,
    'list': state.exemptionManagment.list,
  };
};

const {
  withRouter,
  fetchTwcList,
  clearTwcList,
  fetchFileData,
  fetchWarrantySequences,
  fetchWarrantyStatus,
  addWarrantyChecked,
  removeWarrantyChecked,
  fetchExemptionManagementList,
  navigateTo,
} = Actions;

const mapDispatchToProps = {
  fetchTwcList,
  fetchFileData,
  clearTwcList,
  fetchWarrantySequences,
  fetchWarrantyStatus,
  addWarrantyChecked,
  removeWarrantyChecked,
  fetchExemptionManagementList,
  navigateTo,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ExemptionManagement)
);
